<template>
	<section class="content-section">
		<div class="row">
			<slot>
				<div class="columns column12">
					<h2 v-if="subtitle" class="subtitle">
						{{ subtitle }}
					</h2>
					<h1>{{ title }}</h1>
					<slot name="extra-heading" />
					<div v-parse-links v-html="content" />
					<slot name="extra-content" />
				</div>
			</slot>
		</div>
	</section>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>
